module.exports = __webpack_public_path__ + "4b927bd511260a396a40c548b8ec5169.svg";